export enum PlcGradeCode {
    A1 = 151,
    A2 = 153,
    A5 = 154,
    A5TC = 156,
    B2 = 157,
}
